document.addEventListener('DOMContentLoaded', function () {

  // LOADER
  var loader = document.getElementById('ku-loader');
  if (loader) {
    setTimeout(function () {
      loader.classList.add('hide');
      setTimeout(function () { loader.style.display = 'none'; }, 900);
    }, 2400);
  }

  // CURSOR
  var cur = document.getElementById('ku-cursor');
  var ring = document.getElementById('ku-ring');
  if (cur && window.innerWidth > 900) {
    var rx = 0, ry = 0, mx = 0, my = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cur.style.left = mx + 'px'; cur.style.top = my + 'px';
    });
    (function anim() {
      rx += (mx - rx) * 0.13; ry += (my - ry) * 0.13;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(anim);
    })();
  }

  // SCROLL NAV
  var nav = document.getElementById('ku-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  // MOBILE NAV
  var hamburger = document.getElementById('ku-hamburger');
  var mobileNav = document.getElementById('ku-mobile-nav');
  var mobileClose = document.getElementById('ku-mob-close');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () { mobileNav.classList.add('open'); });
    mobileClose.addEventListener('click', function () { mobileNav.classList.remove('open'); });
  }

  // SCROLL REVEAL
  function checkReveal() {
    document.querySelectorAll('.ku-reveal').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) {
        el.classList.add('in');
      }
    });
  }
  window.addEventListener('scroll', checkReveal);
  checkReveal();

  // FILTER BUTTONS
  document.querySelectorAll('.ku-f-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.ku-f-btn').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // SIZE BUTTONS
  document.querySelectorAll('.ku-size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.ku-size-btn').forEach(function (b) { b.classList.remove('sel'); });
      this.classList.add('sel');
    });
  });
// SEARCH OVERLAY
  var searchOpen = document.getElementById('ku-search-open');
  var searchOverlay = document.getElementById('ku-search-overlay');
  var searchClose = document.getElementById('ku-search-close');
  var searchX = document.getElementById('ku-search-x');
  var searchInput = document.getElementById('ku-search-input');
  function openSearch() {
    searchOverlay.classList.add('open');
    setTimeout(function(){ if(searchInput) searchInput.focus(); }, 300);
    document.body.style.overflow = 'hidden';
  }
  function closeSearch() {
    searchOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (searchOpen) searchOpen.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchX) searchX.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeSearch();
  });
});